import { Text } from '../typography';
import './index.css';

function Label({ id, text, description, required, labelFor }) {

    return (
        <div id={id} className="bccampus-label">
            <div>
                <Text strong
                    id={labelFor ? `${labelFor}_label` : undefined}
                >
                    {text}
                </Text>
            {required && <span className="bccampus-label__required">*</span>}
            </div>
            {description &&
                <Text
                    id={labelFor ? `${labelFor}_desc` : undefined}
                >
                    {description}
                </Text>
            }
        </div>
    )
}

export default Label;
